import { useTranslation } from 'react-i18next';

export function NotificationsFooter({ context }) {
    const { t } = useTranslation('basic');
    const { loading, loadMore, pagination } = context || {};
    const hasMore = pagination && pagination.page < pagination.pages;

    if (!hasMore) return null;

    return (
        <div className='notificationsList_footer'>
            <button
                type='button'
                className='notificationsList_loadMore'
                disabled={loading}
                onClick={loadMore}
            >
                {loading
                    ? t('notifications_loading')
                    : t('notifications_load_more')}
            </button>
        </div>
    );
}
